import { render } from "./CategoriesPage.vue?vue&type=template&id=13416c5c"
import script from "./CategoriesPage.vue?vue&type=script&lang=js"
export * from "./CategoriesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__